import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Printer, Loader2, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { TermPrintCard } from "@/components/TermPrintCard";

export default function StudySheetPrint() {
  const { id } = useParams();
  const [sheet, setSheet] = useState(null);
  const [error, setError] = useState(false);
  const [withComics, setWithComics] = useState(true);

  useEffect(() => { api.get(`/study-sheets/${id}`).then((r) => setSheet(r.data)).catch(() => setError(true)); }, [id]);

  if (error) return <p className="py-24 text-center font-bold" data-testid="sheet-not-found">Foglio non trovato.</p>;
  if (!sheet) return <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin" /></div>;

  return (
    <main className="mx-auto max-w-4xl px-5 pb-24 pt-10 sm:px-8 print:max-w-none print:p-0" data-testid="sheet-print-page">
      <div className="ink-box mb-10 flex flex-wrap items-center gap-4 rounded-3xl bg-white p-5 print:hidden">
        <Link to="/docente" data-testid="sheet-back-link" className="flex items-center gap-1 font-extrabold hover:underline"><ArrowLeft className="h-4 w-4" /> Area docente</Link>
        <label className="flex items-center gap-2 font-bold">
          <input type="checkbox" checked={withComics} onChange={(e) => setWithComics(e.target.checked)} data-testid="sheet-with-comics" className="h-4 w-4" /> Includi fumetti
        </label>
        <button onClick={() => window.print()} data-testid="sheet-print-button" className="ink-box-sm ink-press ml-auto flex items-center gap-2 rounded-full bg-[var(--sky)] px-5 py-2 font-extrabold text-white">
          <Printer className="h-4 w-4" /> Stampa / Salva PDF
        </button>
      </div>
      <header className="mb-8 border-b-[3px] border-black pb-4">
        <p className="text-xs font-extrabold uppercase tracking-widest text-neutral-600">Foglio di studio</p>
        <h1 className="font-display text-4xl font-bold" data-testid="sheet-title">{sheet.title}</h1>
        <p className="font-bold text-neutral-600">{sheet.terms.length} parole da studiare · Nome: ____________________</p>
      </header>
      <div className="space-y-6" data-testid="sheet-term-list">
        {sheet.terms.map((t) => <TermPrintCard key={t.id} term={t} withComic={withComics} />)}
      </div>
    </main>
  );
}
